















































import Vue from 'vue';
import * as Enums from '@/enums.ts';
import * as Util from '@/util.ts';
import * as c from '@/constants.ts';
import firebase from 'firebase/app';

export default Vue.extend({
  data() {
    return {
      locales: c.LOCALES,
      signInInitialized: false,
    };
  },
  computed: {
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    isDeliveryMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.delivery;
    },
    currentClientUser(): ClientUser {
      return this.$store.state.currentClientUser;
    },
    userId(): string {
      return this.$store.state.userId.substr(0, c.USER_ID_CUTOFF);
    },
  },
  methods: {
    getOrderingFromString(): string {
      return Util.getOrderingFromString();
    },
    showSignInFunc() {
      Util.rootComponent.showSignInFunc();
    },
    signOut() {
      Util.signOut();
    },
  },
});
